import { type CumulativeScholarship, FULL_SCHOLARSHIP_LEVEL } from 'Scholarship';

export function isFullScholarship(scholarship: CumulativeScholarship | null | undefined) {
    return !!(scholarship?.level === FULL_SCHOLARSHIP_LEVEL);
}

export function isPartialScholarship(scholarship: CumulativeScholarship | null | undefined) {
    return !!(scholarship && !isFullScholarship(scholarship));
}
